import { useEffect, useState } from "react";
import { Button, Text, View } from "react-native-ui-lib";
import {
  GlobalSettingsContext,
  UseGlobalSettingsContext,
} from "../../utilities/global-settings/context";
import { useGlobalSettings } from "../../utilities/global-settings/hooks";

export interface GlobalSettingsControllerProps {
  children?: React.ReactNode;
}

export const GlobalSettingsController = ({
  children,
}: GlobalSettingsControllerProps) => {
  const [error, setError] = useState(false);
  const useGlobalSettingsRepsonse = useGlobalSettings();
  const { queryGlobalSettings } = useGlobalSettingsRepsonse;

  useEffect(() => {
    setError(false);
    queryGlobalSettings().catch((e: any) => {
      setError(true);
    });
  }, []);

  if (error) {
    return (
      <View>
        <Text>Failed to load settings.</Text>
        <Button>Try Again</Button>
      </View>
    );
  }

  if (!useGlobalSettingsRepsonse.globalSettings) return <View />;

  return (
    <UseGlobalSettingsContext.Provider value={useGlobalSettingsRepsonse}>
      <GlobalSettingsContext.Provider
        value={useGlobalSettingsRepsonse.globalSettings}
      >
        {children}
      </GlobalSettingsContext.Provider>
    </UseGlobalSettingsContext.Provider>
  );
};
